'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.LOG_EVENTS = exports.EVENT_SOURCES = exports.EVENT_LEVELS = void 0;
var EVENT_LEVELS;
(function (EVENT_LEVELS) {
    EVENT_LEVELS["debug"] = "DEBUG";
    EVENT_LEVELS["info"] = "INFO";
    EVENT_LEVELS["warn"] = "WARN";
    EVENT_LEVELS["error"] = "ERROR";
})(EVENT_LEVELS = exports.EVENT_LEVELS || (exports.EVENT_LEVELS = {}));
var EVENT_SOURCES;
(function (EVENT_SOURCES) {
    EVENT_SOURCES["backend"] = "backend";
    EVENT_SOURCES["client"] = "client";
    EVENT_SOURCES["dashboard"] = "dashboard";
    EVENT_SOURCES["ios"] = "ios";
    EVENT_SOURCES["android"] = "android";
    EVENT_SOURCES["aiService"] = "aiService";
    EVENT_SOURCES["eveClient"] = "eveClient";
    EVENT_SOURCES["dynamicAppClient"] = "dynamicAppClient";
    EVENT_SOURCES["quickLauncher"] = "quickLauncher";
    EVENT_SOURCES["livePointer"] = "livePointer";
    EVENT_SOURCES["webhook"] = "webhook";
})(EVENT_SOURCES = exports.EVENT_SOURCES || (exports.EVENT_SOURCES = {}));
exports.LOG_EVENTS = {
    /**
     * Room events
     */
    roomCreated: 'ROOM_CREATED',
    guidCreated: 'GUID_CREATED',
    dashboardConnected: 'DASHBOARD_CONNECTED',
    mobileConnected: 'MOBILE_CONNECTED',
    mobileReconnected: 'MOBILE_RECONNECTED',
    mobileDisconnected: 'MOBILE_DISCONNECTED',
    roomEnded: 'ROOM_ENDED',
    magicMarkerDrawingSent: 'MAGIC_MARKER_DRAWING_SENT',
    magicMarkerDrawingReceived: 'MAGIC_MARKER_DRAWING_RECEIVED',
    agentImageUpload: 'AGENT_IMAGE_UPLOAD',
    agentVideo: 'AGENT_VIDEO',
    agentFaceMeet: 'AGENT_FACE_MEET',
    agentPhoto: 'AGENT_PHOTO',
    agentScreen: 'AGENT_SCREEN',
    agentDesktopSharing: 'AGENT_DESKTOP_SHARING',
    agentCoBrowsing: 'AGENT_COBROWSING',
    agentBoth: 'AGENT_BOTH',
    // sent when the client sends the image, not indicates that it was actually received
    imageReceived: 'IMAGE_RECEIVED',
    videoReceived: 'VIDEO_RECEIVED',
    videoReady: 'VIDEO_READY',
    videoPausedByCustomer: 'VIDEO_PAUSED_BY_CUSTOMER',
    videoPausedByExpert: 'VIDEO_PAUSED_BY_EXPERT',
    videoResumed: 'VIDEO_RESUMED',
    imageSnapped: 'IMAGE_SNAPPED',
    imageSaved: 'IMAGE_SAVED',
    imageSent: 'IMAGE_SENT',
    imageAnnotated: 'IMAGE_ANNOTATED',
    imageSentByClient: 'IMAGE_SENT_BY_CLIENT',
    imageReceivedByClient: 'IMAGE_RECEIVED_BY_CLIENT',
    visualJourneyTotalImagesUploaded: 'VISUAL_JOURNEY_TOTAL_IMAGES_UPLOADED',
    cleaningVirusFailed: { type: 'CLEANING_VIRUS_FAILED', level: EVENT_LEVELS.error },
    savingHistoryImage: 'SAVING_HISTORY_IMAGE',
    savingLibraryImage: 'SAVING_LIBRARY_IMAGE',
    dashboardSendingImage: 'DASHBOARD_SENDING_IMAGE',
    savingResource: 'SAVING_RESOURCE',
    uploadingLocalImage: 'UPLOADING_LOCAL_IMAGE',
    uploadingClipboardImage: 'UPLOADING_CLIPBOARD_IMAGE',
    savingSnapshot: 'SAVING_SNAPSHOT',
    agentImageUploadStarted: 'AGENT_IMAGE_UPLOAD_STARTED',
    agentImageUploadSuccess: 'AGENT_IMAGE_UPLOAD_SUCCESS',
    imageUploadFailed: { type: 'IMAGE_UPLOAD_FAILED', level: EVENT_LEVELS.error },
    uploadLimitReached: { type: 'UPLOAD_LIMIT_REACHED', level: EVENT_LEVELS.error },
    agentImageDownloadStarted: 'AGENT_IMAGE_DOWNLOAD_STARTED',
    agentImageDownloadSuccess: 'AGENT_IMAGE_DOWNLOAD_SUCCESS',
    agentImageDownloadFailed: { type: 'AGENT_IMAGE_DOWNLOAD_FAILED', level: EVENT_LEVELS.error },
    agentLoadedCustomerImage: 'AGENT_LOADED_CUSTOMER_IMAGE',
    retryingImageDownload: 'RETRYING_IMAGE_DOWNLOAD',
    customerUploadingAnImage: 'CUSTOMER_UPLOADING_AN_IMAGE',
    customerUploadingAVideo: 'CUSTOMER_UPLOADING_A_VIDEO',
    customerImageUploadStarted: 'CUSTOMER_IMAGE_UPLOAD_STARTED',
    customerImageUploadSuccess: 'CUSTOMER_IMAGE_UPLOAD_SUCCESS',
    customerImageUploadFailed: { type: 'CUSTOMER_S3_IMAGE_UPLOAD_FAILED', level: EVENT_LEVELS.error },
    customerResendingImage: 'CUSTOMER_RESENDING_IMAGE',
    imageSendingDelayed: 'IMAGE_SENDING_DELAYED',
    imageSendingFailed: 'IMAGE_SENDING_FAILED',
    videoSentByClient: 'VIDEO_SENT_BY_CLIENT',
    videoUploadFailed: { type: 'VIDEO_UPLOAD_FAILED', level: EVENT_LEVELS.error },
    videoDownloadFailed: 'VIDEO_DOWNLOAD_FAILED',
    mouseShareActivated: 'MOUSE_SHARE_ACTIVATED',
    roomCustomerUpdated: 'ROOM_CUSTOMER_UPDATED',
    roomExpired: 'ROOM_EXPIRED',
    SMSInvited: 'SMS_INVITED',
    emailInvited: 'EMAIL_INVITED',
    observerInvited: 'OBSERVER_INVITED',
    inviteResolution: 'INVITE_RESOLUTION',
    mobileNetworkChanged: 'MOBILE_NETWORK_CHANGED',
    roomCancelled: 'ROOM_CANCELLED',
    imageUploadReason: 'IMAGE_UPLOAD_REASON',
    photoReason: 'PHOTO_REASON',
    imageUploadBlocked: 'IMAGE_UPLOAD_BLOCKED',
    visibilityChanged: 'VISIBILITY_CHANGED',
    sync: 'SYNC',
    videoBandwidthStabilized: 'VIDEO_BANDWIDTH_STABILIZED',
    lowVideoBandwidthDetected: { type: 'LOW_VIDEO_BANDWIDTH_DETECTED', level: EVENT_LEVELS.warn },
    connectivityDifficulties: 'CONNECTIVITY_DIFFICULTIES',
    customerUnauthorizedAccess: 'CUSTOMER_UNAUTHORIZED_ACCESS',
    agentSwitchedToImageUpload: 'AGENT_SWITCHED_TO_IMAGE_UPLOAD',
    agentSwitchedToPhoto: 'AGENT_SWITCHED_TO_PHOTO',
    agentSwitchedToVideoStream: 'AGENT_SWITCHED_TO_VIDEOSTREAM',
    agentSwitchedToScreenShare: 'AGENT_SWITCHED_TO_SCREENSHARE',
    agentSwitchedToCoBrowsing: 'AGENT_SWITCHED_TO_COBROWSING',
    agentSwitchedToDesktopSharing: 'AGENT_SWITCHED_TO_DESKTOP_SHARING',
    agentScreenshotFailed: { type: 'AGENT_FAILED_TO_TAKE_A_SCREENSHOT', level: EVENT_LEVELS.error },
    dashboardLoginViewLoaded: 'DASHBOARD_LOGIN_VIEW_LOADED',
    dashboardInviteViewLoaded: 'DASHBOARD_INVITE_VIEW_LOADED',
    dashboardModuleLoaded: 'DASHBOARD_MODULE_LOADED',
    dashboardMainViewLoaded: 'DASHBOARD_MAIN_VIEW_LOADED',
    clientImageUploadViewLoaded: 'CLIENT_IMAGE_UPLOAD_VIEW_LOADED',
    clientVideoViewLoaded: 'CLIENT_VIDEO_VIEW_LOADED',
    clientDesktopShareWaitingForPreScreenApproval: 'CLIENT_DESKTOP_SHARE_WAITING_FOR_PRE_SCREEN_APPROVAL',
    clientDesktopSharePreScreenApprovalAccepted: 'CLIENT_DESKTOP_SHARE_PRE_SCREEN_APPROVAL_ACCEPTED',
    clientDesktopSharingViewLoaded: 'CLIENT_DESKTOP_SHARE_VIEW_LOADED',
    clientPhotoViewLoaded: 'CLIENT_PHOTO_VIEW_LOADED',
    customerImageDownloadStarted: 'CUSTOMER_IMAGE_DOWNLOAD_STARTED',
    customerImageDownloadFailed: { type: 'CUSTOMER_IMAGE_DOWNLOAD_FAILED', level: EVENT_LEVELS.error },
    customerImageDownloadSuccess: 'CUSTOMER_IMAGE_DOWNLOAD_SUCCESS',
    lowBandwidthDialogResolution: 'LOW_BANDWIDTH_DIALOG_RESOLUTION',
    openingLibraryDialog: 'OPENING_LIBRARY_DIALOG',
    customerInPhotoGalleryPage: 'CUSTOMER_IN_PHOTOGALLERY_PAGE',
    customerClosedPhotoGallery: 'CUSTOMER_CLOSED_PHOTOGALLERY_PAGE',
    videoStreamFailed: { type: 'VIDEOSTREAM_FAILED', level: EVENT_LEVELS.error },
    photoStreamFailed: { type: 'PHOTO_STREAM_FAILED', level: EVENT_LEVELS.error },
    waitingForTapTheCameraButton: 'WAITING_FOR_TAP_THE_CAMERA_BUTTON',
    customerOpenedTheCamera: 'CUSTOMER_OPENED_THE_CAMERA',
    customerClosedTheCamera: 'CUSTOMER_CLOSED_THE_CAMERA',
    endMeetingPopup: 'END_MEETING_POP_UP',
    customerEndedTheMeeting: 'CUSTOMER_ENDED_THE_MEETING',
    syncError: { type: 'SYNC_ERROR', level: EVENT_LEVELS.warn },
    snapshotReminderShown: 'SNAPSHOT_REMINDER_SHOWN',
    snapshotReminderClosed: 'SNAPSHOT_REMINDER_CLOSED',
    waitingForCameraPreApproval: 'WAITING_FOR_CAMERA_PRE_APPROVAL',
    cameraPreApprovalAccepted: 'CAMERA_PRE_APPROVAL_ACCEPTED',
    receivedMessage: 'RECEIVED_MESSAGE',
    connectivityCheck: 'CONNECTIVITY_CHECK',
    recognizeStart: 'RECOGNIZE_START',
    recognizeSuccess: 'RECOGNIZE_SUCCESS',
    recognizeFail: 'RECOGNIZE_FAIL',
    analyzeStart: 'ANALYZE_START',
    analyzeSuccess: 'ANALYZE_SUCCESS',
    analyzeFail: 'ANALYZE_FAIL',
    socketVersionMismatch: 'SOCKET_VERSION_MISMATCH',
    audioSupportDetected: 'AUDIO_SUPPORT_DETECTED',
    audioIsNotSupported: 'AUDIO_IS_NOT_SUPPORTED',
    failedToEstablishAudioStreaming: 'FAILED_TO_ESTABLISH_AUDIO_STREAMING',
    audioMuted: 'AUDIO_MUTED',
    audioUnmuted: 'AUDIO_UNMUTED',
    sendEmailSuccess: 'SEND_EMAIL_SUCCESS',
    sendEmailFailed: 'SEND_EMAIL_FAILED',
    agentChangedLanguage: 'AGENT_CHANGED_LANGUAGE',
    /*
     *  New wizard
     * */
    attemptToStartSession: 'ATTEMPT_TO_START_SESSION',
    sessionStartedSuccessfully: 'SESSION_STARTED_SUCCESSFULLY',
    failedToStartSession: 'FAILED_TO_START_SESSION',
    createSessionRequest: 'CREATE_SESSION_REQ',
    sessionCreated: 'SESSION_CREATED',
    sessionCreationFailed: 'SESSION_CREATION_FAILED',
    joinSessionRoom: 'JOIN_SESSION_ROOM_REQ',
    joinSessionRoomFailed: 'JOIN_SESSION_ROOM_FAILED',
    successfullyJoinedSessionRoom: 'SUCCESSFULLY_JOINED_SESSION_ROOM',
    endSessionFailed: 'END_SESSION_FAILED',
    inviteInfoModalOpen: 'INVITE_METHOD_INFO_OPEN',
    inviteInfoModalCanceled: 'INVITE_METHOD_INFO_CANCELED',
    inviteInfoChanged: 'INVITE_METHOD_INFO_CHANGED',
    wizardStepChanged: 'INVITE_FLOW_STEP_CHANGED',
    tosRepromptSent: 'TOS_REPROMPT_SENT_BY_AGENT',
    /*
     * Sharing images events
     * */
    shareImageSaveLocallySuccess: 'SHARE_IMAGE_SAVE_LOCALLY_SUCCESS',
    shareImageSaveLocallyDownloadFailure: 'SHARE_IMAGE_SAVE_LOCALLY_DOWNLOAD_FAILURE',
    shareImageSaveLocallySaveFailure: 'SHARE_IMAGE_SAVE_LOCALLY_SAVE_FAILURE',
    shareImageCopyToClipboardSuccess: 'SHARE_IMAGE_COPY_TO_CLIPBOARD_SUCCESS',
    shareMultipleImagesCopyToClipboardSuccess: 'SHARE_MULTIPLE_IMAGES_COPY_TO_CLIPBOARD_SUCCESS',
    shareImageCopyToClipboardUploadFailure: 'SHARE_IMAGE_COPY_TO_CLIPBOARD_UPLOAD_FAILURE',
    shareImageCopyToClipboardCopyFailure: 'SHARE_IMAGE_COPY_TO_CLIPBOARD_COPY_FAILURE',
    shareMultipleImagesCopyToClipboardCopyFailure: 'SHARE_MULTIPLE_IMAGES_COPY_TO_CLIPBOARD_COPY_FAILURE',
    shareImageFetchSignedDataFailure: 'SHARE_IMAGE_FETCH_SIGNED_DATA_FAILURE',
    /*
     * Copy text to clipboard events
     * */
    shareCopyTextToClipboardSuccess: 'SHARE_COPY_TEXT_TO_CLIPBOARD_SUCCESS',
    shareCopyTextToClipboardFailure: 'SHARE_COPY_TEXT_TO_CLIPBOARD_FAILURE',
    /**
     * Opentok events
     */
    opentokSessionCreated: 'OPENTOK_SESSION_CREATED',
    opentok: 'OPENTOK',
    opentokError: { type: 'OPENTOK_ERROR', level: EVENT_LEVELS.warn },
    opentokWebookRecieved: 'OPENTOK_WEBOOK_RECIEVED',
    opentokWebookFileCopyStarted: 'OPENTOK_WEBOOK_FILE_COPY_STARTED',
    opentokWebookFileCopyFailed: 'OPENTOK_WEBOOK_FILE_COPY_FAILED',
    opentokWebookFileCopySuccess: 'OPENTOK_WEBOOK_FILE_COPY_SUCCESS',
    /**
     * Turn events
     */
    turn: 'TURN',
    turnError: { type: 'TURN_ERROR', level: EVENT_LEVELS.warn },
    /**
     * Bundle events
     */
    bundleLinkNotFound: { type: 'BUNDLE_LINK_NOT_FOUND', level: EVENT_LEVELS.error },
    /**
     * MediaServer events
     */
    mediaServerSessionCreated: 'MEDIA_SERVER_SESSION_CREATED',
    mediaServer: 'MEDIA_SERVER',
    closeMediaServerSession: 'CLOSE_MEDIA_SERVER_SESSION',
    closeMediaServerSessionError: { type: 'CLOSE_MEDIA_SERVER_SESSION_ERROR', level: EVENT_LEVELS.warn },
    startRecording: 'START_RECORDING',
    stopRecording: 'STOP_RECORDING',
    failedToStartRecording: { type: 'FAILED_TO_START_RECORDING', level: EVENT_LEVELS.warn },
    failedToStopRecording: { type: 'FAILED_TO_STOP_RECORDING', level: EVENT_LEVELS.warn },
    webRTCSupported: 'WEBRTC_SUPPORTED',
    /**
     * SMS events
     */
    phoneNumberValidationStarted: 'PHONE_NUMBER_VALIDATION_STARTED',
    phoneNumberValidatedSuccessfully: 'PHONE_NUMBER_VALIDATED_SUCCESSFULLY',
    phoneNumberValidationFailed: 'PHONE_NUMBER_VALIDATION_FAILED',
    phoneNumberValidatedUnexpectedError: 'PHONE_NUMBER_LOOKUP_UNEXPECTED_ERROR',
    // before sending sms request
    sendingSmsRequest: 'SENDING_SMS_REQUEST',
    // when the gateway accepted delivery request
    smsSent: 'SMS_SENT',
    // when the gateway rejected delivery request
    smsSendingFailed: { type: 'SMS_SENDING_FAILED', level: EVENT_LEVELS.error },
    // delivery status received from gateway
    smsDeliveryStatus: 'SMS_DELIVERY_STATUS',
    smsReceivedReply: 'SMS_RECEIVED_REPLY',
    smsNumberLookupResult: 'SMS_NUMBER_LOOKUP_RESULT',
    smsNumberLookupUserAction: 'SMS_NUMBER_LOOKUP_USER_ACTION',
    smsRateLimitExceed: 'SMS_RATE_LIMIT_EXCEED',
    failedToSetSmsConfig: 'FAILED_TO_SET_SMS_CONFIG',
    failedToSetSmsDeliveryStatus: 'FAILED_TO_SET_SMS_DELIVERY_STATUS',
    analyzeSmsResult: 'ANALYZE_SMS_RESULT',
    analyzeSmsResultFailed: 'ANALYZE_SMS_RESULT_FAILED',
    emailRateLimitExceed: { type: 'EMAIL_RATE_LIMIT_EXCEED', level: EVENT_LEVELS.error },
    /**
     * Salesforce Notifications
     */
    failedToAddToQueueNotification: { type: 'FAILED_TO_ADD_TO_QUEUE_NOTIFICATION', level: EVENT_LEVELS.error },
    notificationAddedToQueue: 'NOTIFICATION_ADDED_TO_QUEUE',
    /**
     * Visual Journey session report generation
     */
    failedToAddToQueueVjSession: { type: 'FAILED_TO_ADD_TO_QUEUE_VISUAL_JOURNEY_SESSION', level: EVENT_LEVELS.error },
    vjSessionAddedToQueue: 'VISUAL_JOURNEY_SESSION_ADDED_TO_QUEUE',
    vjReportUploadedToCustomerS3: 'VISUAL_JOURNEY_REPORT_UPLOADED_TO_CUSTOMER_S3',
    vjReportUploadedToCustomerS3Failed: {
        type: 'VISUAL_JOURNEY_REPORT_UPLOADED_TO_CUSTOMER_S3_FAILED',
        level: EVENT_LEVELS.error
    },
    failedVjReportUploadedInternally: {
        type: 'FAILED_VISUAL_JOURNEY_REPORT_UPLOADED_TO_TECHSEE_S3',
        level: EVENT_LEVELS.error
    },
    /**
     * Visual Journey call external api
     */
    vjCallExternalApiAuthFail: 'VJ_CALL_EXTERNAL_API_AUTH_FAIL',
    vjCallExternalApiFail: { type: 'VJ_CALL_EXTERNAL_API_FAIL', level: EVENT_LEVELS.error },
    vjCallExternalApiSuccess: 'VJ_CALL_EXTERNAL_API_SUCCESS',
    /**
     * Scanner events
     */
    vjScanRequest: 'VISUAL_JOURNEY_SCAN_REQUEST',
    vjScanRequestFailed: 'VISUAL_JOURNEY_SCAN_REQUEST_FAILED',
    scanRequest: 'SCAN_REQUEST',
    scanResult: 'SCAN_RESULT',
    scanFailed: { type: 'SCAN_FAILED', level: EVENT_LEVELS.error },
    /**
     * Smart events
     */
    smartAnalysisStarted: 'SMART_ANALYZE_STARTED',
    smartAnalysis: 'SMART_ANALYZE',
    smartAnalysisFeedback: 'SMART_FEEDBACK',
    smartAnalysisError: { type: 'SMART_ERROR', level: EVENT_LEVELS.error },
    smartAnalysisResult: 'SMART_RESULT',
    /**
     * Mobile and native events
     */
    clientLocation: 'CLIENT_LOCATION',
    clientLocationError: 'CLIENT_LOCATION_ERROR',
    clientLocationDenied: 'CLIENT_LOCATION_DENIED',
    clientLocationAddress: 'CLIENT_LOCATION_ADDRESS',
    clientLocationAddressError: 'CLIENT_LOCATION_ADDRESS_ERROR',
    findQualityFailed: { type: 'FIND_IMAGE_QUALITY_FAILED', level: EVENT_LEVELS.error },
    findQualitySucceeded: 'FIND_IMAGE_QUALITY_SUCCEEDED',
    cameraOpened: 'CAMERA_OPENED',
    idleNotification: 'IDLE_NOTIFICATION',
    clientLoading: 'CLIENT_LOADING',
    clientLoadingError: { type: 'CLIENT_LOADING_ERROR', level: EVENT_LEVELS.error },
    parseFullUrlError: { type: 'PARSE_FULLURL_ERROR', level: EVENT_LEVELS.error },
    requestErrorInLoader: { type: 'REQUEST_ERROR_IN_LOADER', level: EVENT_LEVELS.error },
    getUrlParamsError: { type: 'GETURLPARAMS_ERROR', level: EVENT_LEVELS.error },
    getFullUrlError: { type: 'GETFULLURL_ERROR', level: EVENT_LEVELS.error },
    getFullUrlSucceeded: { type: 'GETFULLURL_SUCCESS', level: EVENT_LEVELS.info },
    techseeMobileLoaded: 'TECHSEE_MOBILE_LOADED',
    userAgentInfo: 'USER_AGENT',
    unsupportedDevice: 'UNSUPPORTED_DEVICE',
    supportedDevice: 'SUPPORTED_DEVICE',
    blacklistStockBrowser: 'BLACKLIST_STOCKBROWSER',
    termsAndConditions: 'TERMS_CONDITIONS',
    endMeetingCancelled: 'END_MEETING_CANCELLED',
    cameraDialogIdleAlert: 'CAMERA_DIALOG_IDLE_ALERT',
    mediaPermissionAllow: 'MEDIA_PERMISSION_ALLOW',
    mediaPermissionModalOpened: 'MEDIA_PERMISSION_MODAL_OPENED',
    mediaPermissionModalClosed: 'MEDIA_PERMISSION_MODAL_CLOSED',
    facemeetBigVideoPinnedUserChanged: 'FACEMEET_BIG_VIDEO_PINNED_USER_CHANGED',
    fieldServicesSkipTOS: 'FIELD_SERVICES_SKIP_TOS',
    unableToPublish: 'UNABLE_TO_PUBLISH',
    customerDisconnectedFromTheInternet: 'CUSTOMER_DISCONNECTED_FROM_THE_INTERNET',
    lowBattery: 'LOW_BATTERY',
    customerTookPicture: 'CUSTOMER_TOOK_PICTURE',
    imageUploaded: 'IMAGE_UPLOADED',
    imageUploadCancelled: 'IMAGE_UPLOAD_CANCELLED',
    termsAccepted: 'TERMS_ACCEPTED',
    termsRejected: 'TERMS_REJECTED',
    redirectingToChrome: 'REDIRECTING_TO_CHROME',
    waitingForTosAcceptance: 'WAITING_FOR_TOS_ACCEPTANCE',
    imageUploadWhenRedirecrionFailed: 'IMAGE_UPLOAD_WHEN_REDIRECTION_FAILED',
    redirectedToStore: 'REDIRECTED_TO_STORE',
    sdkVersionValidation: 'SDK_VERSION_VALIDATION',
    redirectToStoreButtonClicked: 'REDIRECTED_TO_STORE_BUTTON_CLICKED',
    speedtestRequested: 'SPEEDTEST_REQUESTED',
    speedtestResults: 'SPEEDTEST_RESULTS',
    customerSurveyDisplayed: 'CUSTOMER_SURVEY_DISPLAYED',
    customerSurveyRated: 'CUSTOMER_SURVEY_RATED',
    agentSurveyStarted: 'AGENT_SURVEY_STARTED',
    agentSurveyStartFailed: { type: 'AGENT_SURVEY_START_FAILED', level: EVENT_LEVELS.error },
    agentSurveyEnd: 'AGENT_SURVEY_END',
    agentSurveyEndFailed: { type: 'AGENT_SURVEY_END_FAILED', level: EVENT_LEVELS.error },
    gettingDeeplinkReferralFailed: { type: 'GETTING_DEEPLINK_REFERRAL_FAILED', level: EVENT_LEVELS.error },
    switchCameraFailed: { type: 'SWITCH_CAMERA_FAILED', level: EVENT_LEVELS.warn },
    switchCameraSuccess: 'SWITCH_CAMERA_SUCCESS',
    /**
     * SSO events
     */
    ssoPreLoginStarted: { type: 'SSO_PRE_LOGIN_STARTED', level: EVENT_LEVELS.info },
    ssoPreLoginFailed: { type: 'SSO_PRE_LOGIN_FAILED', level: EVENT_LEVELS.error },
    ssoPreLoginSuccess: 'SSO_PRE_LOGIN_SUCCESS',
    ssoLoginResponseReceived: 'SSO_LOGIN_RESPONSE_RECEIVED',
    ssoLoginSuccess: 'SSO_LOGIN_SUCCESS',
    ssoLoginFailed: { type: 'SSO_LOGIN_FAILED', level: EVENT_LEVELS.error },
    ssoWithCommunityUrl: 'SSO_WITH_COMMUNITY_URL',
    /**
     * System events
     */
    failedToEndRoom: { type: 'FAILED_TO_END_ROOM', level: EVENT_LEVELS.error },
    failedToAddMeeting: { type: 'FAILED_TO_ADD_MEETING', level: EVENT_LEVELS.error },
    uncaughtException: { type: 'UNCAUGHT_EXCEPTION', level: EVENT_LEVELS.error },
    /**
     * Captcha Events
     */
    captchaGenerated: 'CAPTCHA_GENERATED',
    captchaSolved: 'CAPTCHA_SOLVED',
    videoSaved: 'VIDEO_SAVED',
    imageUploadStarted: 'AGENT_IMAGE_UPLOAD_STARTED',
    imageUploadSuccess: 'AGENT_IMAGE_UPLOAD_SUCCESS',
    userLoggedIn: 'USER_LOGGED_IN',
    userLoggedOut: 'USER_LOGGED_OUT',
    loginRateLimit: 'LOGIN_RATE_LIMIT',
    userAgent: 'USER_AGENT',
    /**
     * Client test upload events
     */
    clientUploadTestStart: 'CLIENT_UPLOAD_TEST_START',
    clientUploadTestError: { type: 'CLIENT_UPLOAD_TEST_ERROR', level: EVENT_LEVELS.error },
    clientUploadTestEnd: 'CLIENT_UPLOAD_TEST_END',
    clientUploadTestEx: { type: 'CLIENT_UPLOAD_TEST_EX', level: EVENT_LEVELS.error },
    /**
     * Simple API
     */
    simpleapiAuthSuccessful: 'SIMPLEAPI_AUTH_SUCCESSFUL',
    simpleapiAuthFailed: { type: 'SIMPLEAPI_AUTH_FAILED', level: EVENT_LEVELS.warn },
    simpleapiHistory: 'SIMPLEAPI_HISTORY',
    simpleapiHistoryFailed: { type: 'SIMPLEAPI_HISTORY_FAILED', level: EVENT_LEVELS.warn },
    simpleapiGetLoginStatus: 'SIMPLEAPI_GET_LOGIN_STATUS_USER',
    /** AI Server events **/
    featureNotSupported: { type: 'AI_FEATURE_NOT_SUPPORTED', level: EVENT_LEVELS.error },
    imageLoadFailed: { type: 'AI_IMAGE_LOAD_FAILED', level: EVENT_LEVELS.error },
    deviceNotSupported: { type: 'AI_DEVICE_NOT_SUPPORTED', level: EVENT_LEVELS.error },
    poseDetectionSetNotFound: { type: 'AI_POSE_DETECTION_SET_NOT_FOUND', level: EVENT_LEVELS.error },
    personSetNotFound: { type: 'AI_PERSON_SET_NOT_FOUND', level: EVENT_LEVELS.error },
    deviceSetNotFound: { type: 'AI_DEVICE_SET_NOT_FOUND', level: EVENT_LEVELS.error },
    unknownError: { type: 'AI_UNKNOWN_ERROR', level: EVENT_LEVELS.error },
    imagePrepSucceed: 'AI_IMAGE_PREP_SUCCEED',
    featureRunSucceed: 'AI_FEATURE_RUN_SUCCEED',
    textAnalysisParamNotSupported: { type: 'AI_TEXT_ANALYSIS_PARAM_NOT_SUPPORTED', level: EVENT_LEVELS.error },
    measurementsParamNotSupported: { type: 'AI_MEASUREMENTS_PARAM_NOT_SUPPORTED', level: EVENT_LEVELS.error },
    cascadeAiParamNotSupported: { type: 'AI_CASCADE_AI_PARAM_NOT_SUPPORTED', level: EVENT_LEVELS.error },
    predictionRunSucceed: 'AI_PREDICTION_RUN_SUCCEED',
    /**
     * Eve events
     */
    evePageLoaded: 'EVE_PAGE_LOADED',
    eveSessionRequest: 'EVE_SESSION_REQ',
    eveSessionCreated: 'EVE_SESSION_CREATED',
    eveSessionCreationFailed: 'EVE_SESSION_CREATION_FAILED',
    eveSessionClosed: 'EVE_SESSION_CLOSED',
    eveSessionExpired: 'EVE_SESSION_EXPIRED',
    eveAnalyzeStepLoaded: 'EVE_ANALYZE_STEP_LOADED',
    eveAnalyzeActionReq: 'EVE_ANALYZE_ACTION_REQ',
    eveAnalyzeActionResult: 'EVE_ANALYZE_ACTION_RESULT',
    eveAnalyzeActionResFailed: 'EVE_ANALYZE_ACTION_RES_FAILED',
    eveWarmTransferReq: 'EVE_WARM_TRANSFER_REQ',
    /**
     * IVR | DynamicApp events
     */
    dynamicAppPageLoaded: 'DYNAMIC_APP_PAGE_LOADED',
    dynamicAppUnexpected: 'DYNAMIC_APP_UNEXPECTED_EVENT_OCCURED',
    dynamicAppSessionRequest: 'DYNAMIC_APP_SESSION_REQ',
    dynamicAppSessionCreated: 'DYNAMIC_APP_SESSION_CREATED',
    dynamicAppSessionReused: 'DYNAMIC_APP_SESSION_REUSED',
    dynamicAppSessionCreationFailed: 'DYNAMIC_APP_SESSION_CREATION_FAILED',
    dynamicAppImageUploadToHistorySuccessfully: 'DYNAMIC_APP_IMAGE_UPLOAD_TO_HISTORY_SUCCESSFULLY',
    dynamicAppImageUploadToHistoryFailed: 'DYNAMIC_APP_IMAGE_UPLOAD_TO_HISTORY_FAILED',
    dynamicAppConnectToAgentRequest: 'DYNAMIC_APP_CONNECT_TO_AGENT_REQUEST',
    dynamicAppGetFlowJsonSuccessfully: 'DYNAMIC_APP_GET_FLOW_JSON_SUCCESSFULLY',
    dynamicAppGetFlowJsonFailed: 'DYNAMIC_APP_GET_FLOW_JSON_FAILED',
    dynamicAppRecordAudioSuccessfully: 'DYNAMIC_APP_RECORD_AUDIO_SUCCESSFULLY',
    dynamicAppRecordAudiofailed: 'DYNAMIC_APP_RECORD_AUDIO_FAILED',
    dynamicAppCaptureSuccessfully: 'DYNAMIC_APP_CAPTURE_SUCCESSFULLY',
    dynamicAppCaptureFailed: 'DYNAMIC_APP_CAPTURE_FAILED',
    dynamicAppFailedSavingForm: 'DYNAMIC_APP_SAVING_FORM_FAILED',
    dynamicAppFailedSavingScreenData: 'DYNAMIC_APP_SAVING_SCREEN_DATA_FAILED',
    dynamicAppGetFlow: 'DYNAMIC_APP_GET_FLOW',
    dynamicAppBuildScreen: 'DYNAMIC_APP_BUILD_SCREEN',
    dynamicAppCloseCameraMediaStream: 'DYNAMIC_APP_CLOSE_CAMERA_MEDIA_STREAM',
    dynamicAppSessionClosed: 'DYNAMIC_APP_SESSION_CLOSED',
    dynamicAppStoreCleared: 'DYNAMIC_APP_STORE_CLEARED',
    /**
     * Quick Launcher
     */
    QLAuthSuccessful: 'QL_AUTH_SUCCESSFULL',
    QLAuthDashboardSuccessful: 'QL_AUTH_DASHBOARD_SUCCESSFULL',
    QLAuthFailed: { type: 'QL_AUTH_FAILED', level: EVENT_LEVELS.error },
    QLAuthDashboardFailed: { type: 'QL_AUTH_DASHBOARD_FAILED', level: EVENT_LEVELS.error },
    /**
     * Live Pointer
     */
    LPStartingCodeValidation: 'LP_STARTING_CODE_VALIDATION',
    LPCodeValidatedSuccessfully: 'LP_CODE_VALIDATED_SUCCESSFULLY',
    LPCodeValidationFailed: 'LP_CODE_VALIDATION_FAILED',
    LPConnecting: 'LP_CONNECTING',
    LPConnectedSuccessfully: 'LP_CONNECTED_SUCCESSFULLY',
    LPConnectionFailed: 'LP_CONNECTION_FAILED',
    LPInitialization: 'LP_INITIALIZATION',
    LPInitializationSuccessful: 'LP_INITIALIZATION_SUCCESSFULL',
    LPInitializationFailed: 'LP_INITIALIZATION_FAILED',
    /**
     * Measurement
     */
    measurementStarted: 'MEASUREMENT_STARTED',
    measurementStopped: 'MEASUREMENT_STOPPED',
    measurementSuccess: 'MEASUREMENT_SUCCESS',
    measurementFailed: 'MEASUREMENT_FAILED',
    /**
     * Flashlight
     */
    flashlightCompatibility: 'FLASHLIGHT_COMPATIBILITY',
    flashlightRequestTurnOn: 'FLASHLIGHT_REQUEST_TURN_ON',
    flashlightRequestTurnOff: 'FLASHLIGHT_REQUEST_TURN_OFF',
    flashlightStatus: 'FLASHLIGHT_STATUS',
    flashlightGuidanceSent: 'FLASHLIGHT_GUIDANCE_SENT',
    /**
     * Login expiration notifiaction
     * */
    loginExpirationNotificationShowed: 'LOGIN_EXPIRATION_NOTIFICATION_SHOWED',
    loginExpirationSuccessLogin: 'LOGIN_EXPIRATION_SUCCESS_LOGIN',
    loginExpirationErrorLogin: 'LOGIN_EXPIRATION_ERROR_LOGIN',
    /**
     * Desktop sharing
     */
    desktopShareUnsupported: 'DESKTOP_SHARING_UNSUPPORTED',
    /**
     * Desktop notification service
     */
    notificationPermissionRequested: 'NOTIFICATION_PERMISSION_REQUESTED',
    notificationPermissionRequestFailed: 'NOTIFICATION_PERMISSION_REQUEST_FAILED',
    /**
     * Session summary
     */
    sessionSummary: 'SESSION_SUMMARY',
    /**
     * Visual Journey
     */
    clientAsDashboardSmsSent: 'CLIENT_AS_DASHBOARD_SMS_SENT',
    visualJourneyPrepareLinks: 'VISUAL_JOURNEY_PREPARE_LINKS',
    visualJourneySmsSent: 'VISUAL_JOURNEY_SMS_SENT',
    visualJourneyAPISmsSent: 'VISUAL_JOURNEY_API_SMS_SENT',
    visualJourneyAuthFailed: 'VISUAL_JOURNEY_AUTH_FAILED',
    visualJourneyError: 'VISUAL_JOURNEY_ERROR',
    visualJourneyInvoked: 'VISUAL_JOURNEY_INVOKED',
    visualJourneyPublishStarted: 'VISUAL_JOURNEY_PUBLISH_STARTED',
    visualJourneyPublishSuccessful: 'VISUAL_JOURNEY_PUBLISH_SUCCESSFUL',
    visualJourneyPublishFailed: { type: 'VISUAL_JOURNEY_PUBLISH_FAILED', level: EVENT_LEVELS.error },
    visualJourneyUploadMedia: 'VISUAL_JOURNEY_MEDIA_UPLOADED',
    visualJourneyUploadMediaFailed: { type: 'VISUAL_JOURNEY_MEDIA_UPLOAD_FAILED', level: EVENT_LEVELS.error },
    visualJourneyUploadImage: 'VISUAL_JOURNEY_IMAGE_UPLOADED',
    visualJourneyUploadImageFailed: { type: 'VISUAL_JOURNEY_IMAGE_UPLOAD_FAILED', level: EVENT_LEVELS.error },
    visualJourneyPlayAudioFailed: 'VISUAL_JOURNEY_PLAY_AUDIO_FAILED',
    visualJourneyTraceLog: 'VISUAL_JOURNEY_TRACE_LOG',
    /**
     * Observation
     */
    guestObserverRedeemOttSuccessful: 'GUEST_OBSERVER_REDEEM_OTT_SUCCESSFUL',
    guestObserverRedeemOttFailed: { type: 'GUEST_OBSERVER_REDEEM_OTT_FAILED', level: EVENT_LEVELS.error },
    guestObserverLoginSuccessful: 'GUEST_OBSERVER_LOGIN_SUCCESSFUL',
    guestObserverLoginFailed: { type: 'GUEST_OBSERVER_LOGIN_FAILED', level: EVENT_LEVELS.error },
    guestObserverGoToLoginPage: 'GUEST_OBSERVER_GO_TO_LOGIN_PAGE',
    observerInvitation: 'OBSERVER_INVITATION',
    guestObserverDetails: 'GUEST_OBSERVER_DETAILS',
    guestObserverDetailsFailed: { type: 'GUEST_OBSERVER_DETAILS_FAILED', level: EVENT_LEVELS.error },
    observerGoToDeepLinkFromWelcomePage: 'OBSERVER_GO_TO_TO_DEEPLINK_FROM_WELCOME_PAGE',
    /**
     * InlineManual
     */
    inlineManualError: 'INLINE_MANUAL_ERROR',
    /**
     * Account Channel
     */
    joinAccountChannelFailed: 'JOIN_ACCOUNT_CHANNEL_FAILED',
    joinAccountChannelSuccess: 'JOIN_ACCOUNT_CHANNEL_SUCCESS',
    disconnectAccountChannel: 'DISCONNECT_ACCOUNT_CHANNEL',
    syncAccountDataFailed: 'SYNC_ACCOUNT_DATA_FAILED',
    /**
     * Room Channel
     */
    roomChannelTrace: 'ROOM_CHANNEL_TRACE',
    /**
     * js API
     */
    jsSessionActiveApiInit: 'JS_SESSION_ACTIVE_API_INIT',
    jsSessionActiveApiFinish: 'JS_SESSION_ACTIVE_API_FINISH',
    jsSessionActiveApiCheck: 'JS_SESSION_ACTIVE_API_CHECK',
    /**
     * Text History
     */
    textHistoryPostSuccessful: 'TEXT_HISTORY_POST_SUCCESSFUL',
    textHistoryPostFailed: { type: 'TEXT_HISTORY_POST_FAILED', level: EVENT_LEVELS.error },
    /**
     * AR Measurement
     */
    arMeasurementActionExecuted: 'AR_MEASUREMENT_ACTION_EXECUTED',
    /**
     * Signed URLS
     */
    getSignedUrlsFailed: { type: 'GET_SIGNED_URLS_FAILED', level: EVENT_LEVELS.error },
    /**
     * Post Resource
     */
    postResourceToSession: 'POST_RESOURCE_TO_SESSION',
    /**
     * Warm Transfer
     */
    warmTransferRequestCreated: 'WARM_TRANSFER_REQUEST_CREATED',
    warmTransferRequestCreationFailed: { type: 'WARM_TRANSFER_REQUEST_CREATION_FAILED', level: EVENT_LEVELS.error },
    warmTransferRoomActivationSucceeded: { type: 'WARM_TRANSFER_ROOM_ACTIVATION_SUCCEEDED' },
    warmTransferRoomActivationFailed: { type: 'WARM_TRANSFER_ROOM_ACTIVATION_FAILED', level: EVENT_LEVELS.error },
    warmTransferRoomStatusPollingSucceeded: { type: 'WARM_TRANSFER_ROOM_STATUS_POLLING_SUCCEEDED' },
    warmTransferRoomStatusPollingFailed: { type: 'WARM_TRANSFER_ROOM_STATUS_POLLING_FAILED', level: EVENT_LEVELS.error },
    /**
     * Interaction Summary
     */
    getInteractionSummaryFailed: { type: 'GET_INTERACTION_SUMMARY_FAILED', level: EVENT_LEVELS.error },
    getInteractionSummarySuccess: 'GET_INTERACTION_SUMMARY_SUCCESS'
};

//# sourceMappingURL=event-logs.constants.js.map
